'use client';

import { useTranslation } from 'react-i18next';

import { ACHName } from '@sola/ark-core/molecules/ach-fields/ach-name.js';
import { InputField } from '@sola/ark-core/molecules/input-field/input-field.js';
import { SupporterAchFieldsEnum } from '@sola/schema/dotcom/supporters/paymentMethods.js';
import { GraphQLSupporterPaymentMethod } from '@sola/schema/dotcom/supporters/schema.generated.js';

export interface UpdateACHFields {
  paymentMethod: GraphQLSupporterPaymentMethod;
}

export const UpdateACHFields: React.FC<UpdateACHFields> = ({
  paymentMethod,
}) => {
  const { t } = useTranslation('my');

  return (
    <>
      <ACHName
        name={SupporterAchFieldsEnum.accountName}
        value={paymentMethod.ach?.accountName}
        required
      />

      <InputField
        name={SupporterAchFieldsEnum.nickname}
        label={t('payments.methodForm.fieldLabels.achNickname')}
        value={paymentMethod.accountNickname}
        hint={t('payments.methodForm.fieldLabels.optional')}
      />
    </>
  );
};
